import ApiRequestManagerInstance from '../ApiRequestManager';
import Content from '../../types/enums/content';
import Rail from '../../classes/rail';
import { ISearchRequest } from '../../types/interfaces/rail';
import { ParentalAge } from '@shared/types/enums/parental';
import { RailDisplayMode, RailType } from '../../types/enums/rail';
import { store } from '../../store/store';
import TranslationManager from '@shared/assets/locale/translationsManager';
import pkg from '../../../package.json';
import FlavourConfig from '@shared/config/flavours';
import DeviceConfig from '@devices/config';



function searchRequest(title?: string, id?: string) {
  const appVersion = pkg.version;
  const appName = FlavourConfig.appName
  const promise = new Promise<Rail[]>(async (resolve) => {
    if (!title) resolve([]);
    try {
      const { channels, events: eventsSlice, user } = store.getState();
      const response: ISearchRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          version: 'v7',
          section: user?.isAnonymous ? 'mediafree' : 'media',
          subsection: 'search',
          type: 'search',
          params: `${title}${id ? `?id=${id}` : ''}?appVersion=${appVersion}&appName=${appName}${DeviceConfig.platform === 'SMARTTV' ? `&userAgent=${navigator.userAgent}` : ''}&speechToText=false`,
        },
        abort: true,
      })) as unknown as ISearchRequest;

      const rails = [];
      const eventsData = channels.channelsData
        ? response.data.sliders.channels.items
          .map((item) => {
            if (channels.channelsData) {
              const channelFound = channels.channelsData.find(
                (channelItem) => {
                  return item.channelCode === channelItem.code;
                }
              );
              if (channelFound?.parentalControl) {
                return undefined;
              }
              if (channelFound) {
                return eventsSlice.currentEvents[channelFound.id];
              }
              return undefined;
            }
          })
          .filter((item) => {
            return item;
          })
        : [];

      if (response.data.sliders.channels.items.length) {
        const railConfig = {
          section: {
            name: 'channels',
            presentationType: RailDisplayMode.SQUARE,
            title: response.data.sliders.channels.title,
          },
        };
        if (eventsData.length) {
          rails.push(
            Rail.constructorWithData(
              railConfig,
              eventsData,
              RailType.REGULAR,
              true
            )
          );
        }
      }

      if (response.data.sliders.shows.items.length) {
        const railConfig = {
          section: {
            name: 'shows',
            presentationType: RailDisplayMode.PHOTO,
            title:
              id && response.data.sliders.shows.items?.length > 1
                ? TranslationManager.get(
                  'COMPONENTS.SEARCH.NO_RESULTS_ID',
                  title
                )
                : response.data.sliders.shows.title,
          },
          shows: {
            data: response.data.sliders.shows.items
              .map((item) => {
                switch (item.kind) {
                  case Content.EPG_EVENT:
                    item.channel = eventsData.find(
                      (event) => event?.eventId === item.eventId
                    )?.channelId;

                    break;
                  case Content.FAST_EVENT:
                  case Content.MEDIA_PRODUCTION:
                    // Filter adult content
                    if (
                      item?.ageCode &&
                      item?.ageCode?.toUpperCase() === ParentalAge.ADULTS
                    ) {
                      return;
                    }

                    // Filter content from adult channels
                    const channel = [
                      ...(channels.channelsData || []),
                      ...(channels.unavailableChannels || []),
                    ]?.find(
                      (channel) =>
                        channel.name === item.channelName ||
                        channel.code === item.channelCode
                    );

                    if (channel?.parentalControl) {
                      return;
                    }

                    // Populate channel if upgradable plan is required
                    item.channel = channel?.id;

                    break;
                }
                return item;
              })
              .filter((item) => !!item),
          },
        };
        if (railConfig.shows.data.length) {
          rails.push(new Rail(railConfig, null, RailType.MOSAIC));
        }
      }
      resolve(rails);
    } catch (e) {
      console.error(e);
      resolve([]);
    }
  });

  return promise;
}

export default searchRequest;
